<template>
  <div class="uni-course-subject courseAdult">
    <el-row>
      <el-col :span="18">
        <div class="course-box">
          <!-- filter-box -->
          <div class="box filter-box">
            <ul class="filter-list">
              <!-- <li class="item">
                <span class="tit">课程类型</span>
                <div style="flex: 1">
                  <el-radio
                    v-for="(item, index) in specialtyCount"
                    :key="index"
                    class="radio"
                    @change="typeChange"
                    v-model="courseType"
                    :label="item.course_type"
                    >{{ item.title }} ({{ item.num }})
                  </el-radio>
                </div>
              </li> -->
              <li class="item">
                <span class="tit">学习进度</span>
                <div>
                  <el-radio
                    v-for="(item, index) in progressMap"
                    :key="index"
                    class="radio"
                    @change="typeChange"
                    v-model="progress"
                    :label="item.type"
                    >{{ item.title }}</el-radio
                  >
                </div>
              </li>
            </ul>
          </div>
          <!-- content-box -->
          <div class="box content-box">
            <div class="titleDiv">
              <el-row>
                <el-col :span="2"><p>学期</p></el-col>
                <el-col :span="4"><p>课程名称</p></el-col>
                <el-col :span="2"><p>学分</p></el-col>
                <el-col :span="5"><p>学习进度</p></el-col>
                <el-col :span="8"><p>操作</p></el-col>
                <el-col :span="3"
                  ><p style="border-style: none">状态</p></el-col
                >
              </el-row>
            </div>
            <ul class="course-list">
              <el-row>
                <li class="item" v-for="item in specialtyDtos" :key="item.id">
                  <el-col :span="2">
                    <p class="p">
                      {{ item.semester }}
                    </p>
                  </el-col>
                  <el-col :span="4">
                    <div class="itemTitle">
<!--                      <span-->
<!--                        class="mark"-->
<!--                        :class="getTypeColor(item.course_type).classes"-->
<!--                        >{{ getTypeColor(item.course_type).text }}</span-->
<!--                      >-->
                      <p class="tit">{{ item.title }}</p>
                    </div>
                  </el-col>
                  <el-col :span="2">
                    <p class="p">
                      <span class="num">{{ item.credit }}</span
                      >学分
                    </p>
                  </el-col>
                  <el-col :span="5">
                    <div class="p">
                      <el-progress
                        class="progress"
                        :percentage="item.percentage"
                      ></el-progress>
                    </div>
                  </el-col>

                  <el-col :span="8">
                    <div class="itemButton" v-if="item.is_start == 1 && item.act_status == 1">
                      <button @click="goRouter('subjectAdult', item)">
                        <em class="iconfont iconshipin"></em><span>去学习</span>
                      </button>
                      <!-- <button
                          @click="goRouterZy(item)"
                        >
                          <em class="iconfont iconicon f14"></em
                          ><span>做作业</span>
                        </button> -->
                        <button v-if="item.course_type == 4 || (item.percentage == 100 && item.exam_type == 2 && (item.exam_status == 1 || item.exam_status == 2 || item.exam_status == 6))" @click="goRoExam(item)">
                          <em class="iconfont iconicon f14"></em>
                          <span>去考试</span>
                        </button>
                      <!-- <div v-if="item.student_type == 1">
                        <button
                          @click="goRouterZy(item)"
                          v-if="item.course_type == 1"
                        >
                          <em class="iconfont iconicon f14"></em
                          ><span>做作业</span>
                        </button>
                        <button
                          @click="goRouterLx(item)"
                          v-if="item.course_type === 2"
                        >
                          <em class="iconfont iconjilu1 f14"></em
                          ><span>去练习</span>
                        </button>
                      </div>

                      <div v-if="item.student_type == 2">
                        <button
                          @click="goRouterLx(item)"
                        >
                          <em class="iconfont iconjilu1 f14"></em
                          ><span>去练习</span>
                        </button>
                      </div> -->

                    </div>
                    <div class="itemButton" v-else>未开放</div>
                  </el-col>

                  <el-col :span="3">
                    <!-- <span class="p" :style="item.rate_type | paperColor">
                      {{ item.rate_type | paperState }}</span> -->
                    <span v-if="item.exam_status == 0" class="p" :style="item.rate_type | paperColor">
                      {{ progressMap[item.rate_type].title }}
                    </span>
                    <span v-if="item.exam_status > 0" class="p" :style="item.exam_status | examStatusColor">
                        {{ courseExamStatusMap[item.exam_status] }}
                    </span>
                  </el-col>
                </li>
              </el-row>
            </ul>
            <!-- 内容为空的时候 -->
            <ComponentEmpty
              title="暂无课程"
              tips
              v-if="specialtyDtos.length == 0"
            />
          </div>
        </div>
      </el-col>

      <el-col :span="6">
        <div class="side-box" v-if="studentMajor">
          <!-- info-box -->
          <div class="box info-box">
            <h2 class="title">{{ studentMajor.professionName }}</h2>
            <!-- <div class="text-center">
              <div class="score" type="primary">
                总学分：{{ studentMajor.credit || 0 }}分
              </div>
            </div> -->
            <div class="mat40 text-center">
              <img
                style="width: 60%"
                src="@/assets/images/undraw_Upvote_re_qn2k.png"
                alt=""
              />
            </div>

            <div class="banner-box">
              <h3 class="h3">专业学习说明</h3>
              <div v-html="studentMajor.profession_content"></div>
            </div>

            <!-- 最新课程 -->
<!--            <div class="banner-box">
              <h3 class="h3"><i class="icon icon3"></i>最新课程</h3>
              <div class="article-list">
                <p
                  v-for="(item, index) in recentCourses"
                  :key="index"
                  class="link"
                  @click="
                    $router.push({
                      name: 'subject',
                      query: {
                        id: item.uuid,
                      },
                    })
                  "
                >
                  <span class="tit">{{ item.title }}</span>
                  <span class="date">{{
                    item.created_at.substring(0, 10)
                  }}</span>
                </p>

                <ComponentEmpty
                  v-if="recentCourses.length == 0"
                  style="padding: 0"
                  imgClass="empty-img-size100"
                  title="暂无最新课程"
                  tips=""
                />
              </div>
            </div>-->
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="tips-box">
      <el-dialog
        title="温馨提示："
        :visible.sync="isShowTips"
        :close-on-click-modal="false"
        :show-close="false"
        width="800px"
        @close="tipsClose">
        <div class="cont">
          <div class="text-box">
            <p class="text">您即将进入在线考试，请务必仔细阅读以下注意事项，确保考试顺利进行：</p>
            <p class="text yuan">
              <span class="bold red">请先强制刷新浏览器</span>
              （可按 Ctrl + F5），清除缓存，确保页面为最新版本，避免因加载异常影响答题。
            </p>
            <p class="text yuan">
              <span class="bold red">考试时长为2小时</span>
              ，计时从您点击“开始考试”后自动开始，一旦启动，时间将持续计算，不可暂停。
            </p>
            <p class="text yuan">
              考试过程中
              <span class="bold red">禁止使用复制、粘贴、截图等操作</span>
              ，系统将记录相关行为，违规将影响成绩。
            </p>
            <p class="text yuan">
              <span class="bold red">考试开始后，无论是否退出页面或关闭浏览器，倒计时均照常进行</span>
              ，2小时结束后系统将自动交卷，请合理安排答题时间。
            </p>
             <p class="text yuan">
              <span class="bold red">“实践课程”先在“去学习”页面里下载课件</span>
              ，根据课件内容完成实践作业后，再进行考试提交
            </p>
            <p class="text yuan">建议您在稳定的网络环境中作答，并使用推荐的浏览器（如：“谷歌浏览器” 最新版），避免意外中断</p>
            <p class="text">请确认准备就绪后再开始考试，祝您发挥出色！</p>
          </div>
          <div style="margin-top: 50px;display: flex;justify-content: space-between;align-items: center;">
            <div>
              <el-checkbox v-model="isReading" :disabled="!isConfirm">我已阅读</el-checkbox>
            </div>
            <div>
              <el-button @click="isShowTips = false">取 消</el-button>
              <el-button type="primary" :disabled="!isConfirm" @click="confirmExamClick">{{ isConfirm ? '确认考试' : (timeNum + '秒') }}</el-button>
            </div>
          </div>
        </div>
        <!-- <span slot="footer" class="dialog-footer"></span> -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getStore, setStore } from "@/utils/localStorage";
import { mapState } from "vuex";
import { getMyCourseAE, getCourseType, getNewCourse } from "@/api/basic.js";
export default {
  name: "courseAdult",
  computed: {
    ...mapState("common", {
      studentMajor: (state) => state.studentMajor,
    }),
  },
  data() {
    return {
      specialtyCount: [],
      // courseType: 0,
      progress: 0,
      progressMap: [
        {
          type: 0,
          title: "全部",
        },
        {
          type: 1,
          title: "待学习",
        },
        {
          type: 2,
          title: "学习中",
        },
        {
          type: 3,
          title: "待考试",
        },
        {
          type: 4,
          title: "已完成",
        },
      ],
      courseExamStatusMap: {
        "2" : "待考试",
        "3" : "阅卷中",
        "4" : "缺考",
        "5" : "已交卷",
        "6" : "考试中",
        "7" : "已完成",
      },
      specialtyDtos: [],
      // recentCourses: [],

      // 提示弹窗
      isShowTips: false,
      isConfirm: false,  //确认按钮可以点击
      timeNum: 0,  //倒计时
      mNum: 30,  //倒计时30秒
      timer: null,  //定时器
      isReading: false,  //是否阅读
      currCourseId: null,  //当前选中的课程id
    };
  },
  created() {
    // this.getSpecialtyCount();
    // this.getRecentSpecialty();
    this.getStudentSpecialty();
  },
  methods: {
    // 确认考试
    confirmExamClick(){
      if(this.isReading){
        this.$router.push({
          name: "onlineTest",
          query: {
            // typeTest: this.type,
            // test_id: this.test_id,
            course_id: this.currCourseId,
            // exam_id: this.exam_id
            page: 'courseAdult',
            is_read: 1,
          },
        });
      }else{
        this.$message.warning("请先勾选“我已阅读”！");
      }
    },
    // 弹窗 提示 关闭
    tipsClose(){
      this.isConfirm = false;
      this.timeNum = 0;
      clearInterval(this.timer);
    },
    // 倒计时
    countDown(){
      this.timeNum = this.mNum;
      this.timer = setInterval(() => {
        this.timeNum--;
        if(this.timeNum > 0){
        }else{
          clearInterval(this.timer);
          this.isConfirm = true;
        }
      }, 1000);
    },
    // 点击 去考试
    goRoExam(item){
      this.currCourseId = item.course_id;
      this.isShowTips = true;
      this.countDown();
      // this.$confirm('该考试开考后，2小时后会自动交卷，且退出考试页面不会影响计时，请考生谨慎点击！', "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      //   customClass: 'exam-tips',
      // }).then(async () => {
      //   this.$router.push({
      //     name: "onlineTest",
      //     query: {
      //       // typeTest: this.type,
      //       // test_id: this.test_id,
      //       course_id: item.course_id,
      //       // exam_id: this.exam_id
      //       page: 'courseAdult',
      //     },
      //   });
      // });
    },
    // 课程类型
    // async getSpecialtyCount() {
    //   const { result } = await getCourseType();
    //   if (result) {
    //     this.specialtyCount = result;

    //     if (result.length > 0) {
    //       this.courseType = result[0].course_type;
    //       this.getStudentSpecialty();
    //     }
    //   }
    // },
    // 课程信息
    async getStudentSpecialty() {
      const saveState = getStore("courseState");
      if (saveState) {
        let state = JSON.parse(saveState);
        // this.courseType = state.courseType;
        this.progress = state.progress;
      }

      const params = {
        // course_type: this.courseType,
        rate_type: this.progress,
      };
      const { result } = await getMyCourseAE(params);
      // if (result) {
        this.specialtyDtos = result || [];
      // }
    },
    /**
     * 最新课程
     */
    // async getRecentSpecialty() {
    //   const { result } = await getNewCourse();
    //   if (result) {
    //     this.recentCourses = result;
    //   }
    // },
    typeChange() {
      this.saveState();
      this.getStudentSpecialty();
    },
    // 存储当前筛选数据
    saveState() {
      setStore("courseState", {
        // courseType: this.courseType,
        progress: this.progress,
      });
    },
    // 路由跳转
    goRouter(url, item) {
      this.$router.push({
        name: url,
        query: {
          id: item.course_id,
          // type: item.course_type,
        },
      });
    },
    // 类型切换改变样式
    getTypeColor(type) {
      switch (type) {
        case 1:
          return {
            classes: "",
            text: "国考",
          };
        case 3:
          return {
            classes: "primary-light",
            text: "综合",
          };
        case 2:
          return {
            classes: "blue-light",
            text: "校考",
          };
        default:
          return {
            classes: "blue-light",
            text: "校考",
          };
      }
    },
    goRouterZy(item) {
      this.$router.push({
        name: "practiceAdult",
        query: {
          courseUuid: item.course_id,
          // courseType: item.course_type,
        },
      });
    },
    goRouterLx(item) {
      let name = item.course_type == 1 ? "章节练习" : "智能练习";
      this.$store.commit("common/changeMenuMutation", { name: name });
      this.$router.push({
        name: "allTest",
        query: {
          courseUuid: item.course_id,
          // course_type: item.course_type,
        },
      });
    },
  },
  filters: {
    //  状态过滤
    // paperState: (value) => {
    // if (value === 0) {
    //   return "待学习";
    // } else if (value > 0 && value < 100) {
    //   return "学习中";
    // } else if (value === 100) {
    //   return "已完成";
    // }
    // },
    //  颜色过滤
    paperColor: (value) => {
      if (value === 1) {
        return "color:#FF4949";
      } else if (value == 2) {
        return "color:#409EFF";
      } else if (value == 4) {
        return "color:#67C23A";
      }
    },
    examStatusColor: (value) => {
      /**
        "2" : "待考试",
        "3" : "待阅卷",
        "4" : "缺考",
        "5" : "已交卷",
        "6" : "考试中",
        "7" : "已完成",
       */
      switch (value) {
        case 2:
          return "color:#2ECC40";
        case 3:
          return "color:#FF851B";
        case 4:
          return "color:#FF4136";
        case 5:
          return "color:#B10DC9";
        case 6:
          return "color:#2ECC40";
        case 7:
          return "color:#004C40 ";
      }
    },
  },
};
</script>

<style lang="scss">
.tips-box{
  .cont{
    .text-box{
      .text{
        font-size: 18px;
        color: #333;
        line-height: 30px;
        &.yuan{
          padding-left: 30px;
          position: relative;
          &::before{
            content: "";
            position: absolute;
            left: 10px;
            top: 10px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #333;
          }
        }
        & + .text{
          margin-top: 14px;
        }
        .red{
          color: red;
        }
      }
    }
  }
}

</style>
<style lang="scss" scoped>
.uni-course-subject {
  .box {
    background: #fff;
  }

  .select-btn {
    width: 75px;
    height: 25px;
    padding: 0;
    margin-top: 10px;
  }

  .dialog-xuanxiu {
    .tit {
      font-size: 18px;
      font-weight: bold;
    }

    .tips {
      color: $textGray;
      font-size: 14px;
      margin-left: 20px;
    }
  }

  .course-box {
    padding: 0 20px;
  }
  .filter-box {
    margin-top: 20px;

    .tit {
      font-size: 16px;
      font-weight: 600;
      margin-right: 20px;
    }

    .filter-list {
      .item {
        display: flex;
        align-items: center;
        line-height: 80px;
        border-bottom: 1px solid $grayBorder;
        padding: 0 20px;
        &:last-child {
          border: none;
        }
      }
    }
  }
  .content-box {
    min-height: 600px;
    margin-top: 10px;
    padding-left: 0;
    padding-right: 0;
    overflow: hidden;
    padding-top: 0;
    .titleDiv {
      width: 100%;
      background-color: #d3e4f4;
      padding: 8px 0;
      p {
        width: 100%;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: #000;
        border-right: 1px solid #fff;
      }
    }
    .course-list {
      width: 100%;
      .item {
        width: 100%;
        border-bottom: 1px solid $grayBorder;
        padding: 30px 0;
        color: $grayLight;
        transition: all 0.3s;
        display: flex;

        &:hover {
          box-shadow: 1px 2px 8px 0 $grayLight2;
        }
        .itemTitle p{
          width: 100%;
          height: 100%;
          // display: flex;
          // align-items: center;
          // justify-content: center;
        }
        .itemButton {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: space-around;
          button {
            width: 100px;
            height: 27px;
            background: none;
            border: 1px solid #eaeaea;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            span {
              color: #666;
              font-size: 13px;
            }
            em {
              color: #fe772e;
              margin-right: 6px;
              line-height: 16px;
              margin-top: 3px;
            }
            &:hover {
              background: #fe772e;
              border-color: #eaeaea;
              span {
                color: #fff;
              }
              em {
                color: #fff;
              }
            }
          }
        }
        .mark {
          //width: 50px;
          white-space: nowrap;
          @include oringe-mark;
          margin: 0 20px 0 22px;
          &.primary-light {
            @include bgColor("primary");
          }

          &.blue-light {
            @include bgColor("primary-lighten");
          }
        }

        .tit {
          width: 150px;
          color: $textColor;
          font-size: 16px;
        }

        .p {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .progress {
          width: 70%;
          display: flex;
          align-items: center;
        }

        .link {
          margin-top: 15px;
          @include uni-oringe-btn(100px, 30px);
        }

        .num {
          font-size: 26px;
          @include fontColor("primary");
          margin-right: 5px;
        }
      }
    }

    // .empty-box {
    //   padding: 20px;
    //   color: $grayLight;
    //   .txt {
    //     font-size: 16px;
    //   }
    // }
  }

  .side-box {
    padding-right: 20px;
  }

  .info-box {
    margin-top: 20px;
    padding: 20px;

    .title {
      font-weight: bold;
      text-align: center;
    }

    .score {
      @include uni-primary-link;
      padding: 4px 0;
      margin: 10px auto 0;
      font-size: 16px;
    }
  }

  .banner-box {
    margin-top: 30px;
    border-top: 1px solid $gray;
    line-height: 25px;

    .h3 {
      margin: 20px 0;
      font-weight: bold;
      display: flex;
      align-items: center;
    }

    .icon {
      width: 20px;
      height: 16px;
      margin-right: 10px;
      &.icon3 {
        @include themeIcon("20");
        background-size: auto auto !important;
      }
    }

    .row {
      @include fontColor("primary");
    }
  }
  .article-list {
    .link {
      display: flex;
      justify-content: space-between;
      color: $textColor;
      margin-top: 6px;
      cursor: pointer;
      .tit {
        flex: 1;
        @extend %ellipse;
      }

      .date {
        color: $textGray;
      }
    }
  }

  // .progress-box {
  //   margin-top: 10px;
  //   overflow: hidden;
  //   padding: 0 20px 20px 20px;

  //   .item {
  //     margin-top: 20px;
  //   }
  // }

  .check-group {
    .label {
      color: $textColor;
    }

    .check {
      text-decoration: underline;
      margin-left: 10px;
    }
  }
}
</style>
